import { appStore } from '../stores'

/**
 * 用户活跃监听
 */
class ActiveWatcher {

  public timeout: number = 60 * 1000 * 30
  public lastTime: number = new Date().valueOf()
  public currentTime: number = new Date().valueOf()
  public timer: NodeJS.Timeout | number | null = null

  // 更新最后活动时间
  public handleActive = () => {
    this.lastTime = new Date().valueOf()
  }

  // 启动活跃监听
  public runWatcher = () => {
    try {
      this.lastTime = new Date().valueOf()
      this.currentTime = new Date().valueOf()
      this.timer = setInterval(() => {
        this.currentTime = new Date().valueOf()
        if (this.currentTime - this.lastTime > this.timeout) {
          console.log(`activeWatcher timeout`)
          clearInterval(Number(this.timer))
          document.removeEventListener('mousemove', this.handleActive)
          // 设置 sessionStorage uaaActiveTimeout 给登录页面使用
          window.sessionStorage.setItem('uaaActiveTimeout', 'activeTimeout')
          appStore.logout()
        }
      }, 60000)
      document.addEventListener('mousemove', this.handleActive)
      document.addEventListener('keydown', this.handleActive)
      console.log(`启动ActiveWatcher成功`)
    } catch (error) {
      console.log(`启动ActiveWatcher失败`)
    }
  }
}

const activeWatcher = new ActiveWatcher()

export { activeWatcher }